import ArrowDownSVG from "../../../../svgs/ArrowDownSVG";

const Frequently = () => {
  return (
    <div className="w-full flex items-start gap-5 border-t border-subColor4 mt-4 px-14 pt-48">
      <div className="w-[23%]">
        <div className="text-[44px] w-[180px] text-subColor5 font-bold leading-[50px]">
          Frequently asked questions.
        </div>
      </div>
      <div className="w-[77%] flex flex-col">
        {/* it will change in future *** its fake structure *** */}
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>Which Vercel plan is right for me?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>Do you offer custom invoicing?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>What are the limits for each plan?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>I went over my limits. What can I do?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>Can I buy additional usage?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>I have a Hobby account, how do I upgrade to a paid plan?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>Is there a limit to how many teams I can have?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>How does Vercel calculate usage?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>I want to transfer a domain name to Vercel. Is there a fee?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-t border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>Do cached responses affect usage?</div>
          <ArrowDownSVG />
        </div>
        <div className="flex items-center justify-between px-6 border-l border-y border-subColor4 py-7 text-subColor5 font-semibold text-[18px] [&>svg>path]:stroke-subColor5">
          <div>How can I manage my spend?</div>
          <ArrowDownSVG />
        </div>
        <div className="w-1/2 h-[138px] border-x border-subColor4">

        </div>
      </div>
    </div>
  );
};

export default Frequently;
